'use strict'

import angular from 'angular'
import ListController from './list.controller'

export default angular.module('updateServerApp.keyboard.list', [])
  .controller('KeyboardListController', ListController)
  .name



// WEBPACK FOOTER //
// ./client/app/keyboard/list/index.js